const NEW_LINE_STRING = `  
`;

export const formatMarkdownString = (mdx: string) => {
  if (!mdx) return mdx;
  return mdx
    .replace(/\\r/g, '\r')
    .replace(/\\n/g, '\n')
    .replace(/(\r\n)|(\n\r)|[\r\n]|(<br ?\/?>)/g, NEW_LINE_STRING);
};
